import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { MobilemenuCollectionCatagoryMappingSchema } from '../MobilemenuCollectionCatagoryMappingSchema';
import { MobilemenuCollectionCatagoryMappingListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'MOBILEMENUTOCOLLECTIONCATEGORY';

export function MobilemenuCollectionCatagoryMapping(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Mobile Menu to Collection Category");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionCategory, setCollectionCategory] = useState();
    const [mobilemenuCollectionCatagoryMappingData, setMobilemenuCollectionCatagoryMappingData] = useState([]);
    const [mobilemenuCollectionCatagoryMapping, setMobilemenuCollectionCatagoryMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionCategoryID: '0',
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(MobilemenuCollectionCatagoryMappingSchema).options({ allowUnknown: true });

    useEffect(() => {
trackPromise(
        getGroupsForDropdown()
)
        getPermissions();
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [mobilemenuCollectionCatagoryMapping.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
            )
    }, [mobilemenuCollectionCatagoryMapping.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMOBILEMENUCOLLECTIONCATEGORYLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITMOBILEMENUCOLLECTIONCATEGORY');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(mobilemenuCollectionCatagoryMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategories = await services.getCollectionCategoryByOperationentity(mobilemenuCollectionCatagoryMapping.operationEntityID);
        setCollectionCategory(collectionCategories);
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, MobilemenuCollectionCatagoryMappingSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, mobilemenuCollectionCatagoryMapping);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const response = await services.getMobilemenuCollectionCatagoryFilterData(mobilemenuCollectionCatagoryMapping);
        setMobilemenuCollectionCatagoryMappingData(response);
    }

    async function editMobilemenuCollectionCatagoryMapping(data) {
        props.history.push({
            pathname: 'mobilemenucollectioncategorytypemapping/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        setMobilemenuCollectionCatagoryMapping({
            ...mobilemenuCollectionCatagoryMapping,
            groupID: '0',
            operationEntityID: '0',
            collectionCategoryID: '0',
        });
        setMobilemenuCollectionCatagoryMappingData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="mobilemenucollectioncategorytypemapping/AddEdit"
                                    buttonText="Add Mobile Menu"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={mobilemenuCollectionCatagoryMapping.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={mobilemenuCollectionCatagoryMapping.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Catagory</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryID"
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            value={mobilemenuCollectionCatagoryMapping.collectionCategoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Catagory--</MenuItem>
                                            {generateDropDownMenu(collectionCategory)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText error>{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, mobilemenuCollectionCatagoryMapping)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <MobilemenuCollectionCatagoryMappingListing 
                                    mobilemenuCollectionCatagoryMappingData={mobilemenuCollectionCatagoryMappingData} 
                                    handleClick={editMobilemenuCollectionCatagoryMapping} 
                                    editEnabled={permissionList.isAddEditEnabled}
                                />

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}